export default __webpack_public_path__ + "assets/images/bonus.47b44e.webp";